import { useLayoutEffect, useRef, useState } from "react";
import { motion } from "framer-motion";

// Keeps focus rings and shadows at the edges from being clipped by overflow: hidden
const BLEED = 8;

// Smoothly follows the height of its content, e.g. when swapping between steps of different sizes
export default function AnimatedHeight({ children, duration = 0.25 }) {
  const contentRef = useRef(null);
  const [height, setHeight] = useState("auto");

  useLayoutEffect(() => {
    const element = contentRef.current;
    if (!element || typeof ResizeObserver === "undefined") return undefined;

    const observer = new ResizeObserver(() => setHeight(element.offsetHeight));
    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  return (
    <motion.div
      initial={false}
      animate={{ height }}
      transition={{ duration, ease: "easeInOut" }}
      style={{ alignSelf: "stretch", overflow: "hidden", margin: -BLEED }}
    >
      <div ref={contentRef} style={{ padding: BLEED }}>
        {children}
      </div>
    </motion.div>
  );
}
